export function normalizeQuoteItem(item) {
  let res = { ...item };
  const currentSection = String(res?.space || res?.section || res?.Space || "").trim();
  if (/^electrical work$/i.test(currentSection)) {
    return { ...res, category: "Approx. Points", quoteMaterial: "Approx. Points" };
  }
  return res;
}

export function normalizeQuoteItems(items = []) {
  return (items || []).map(normalizeQuoteItem);
}

const textFieldsThatMakeQuoteLine = [
  "item",
  "itemName",
  "name",
  "itemDetails",
  "description",
  "space",
  "section",
  "category",
  "quoteMaterial",
  "internalFinish",
  "externalFinish",
  "remarks",
];

function hasText(value) {
  if (value == null) return false;
  if (typeof value === "object") return !!(value._id || value.name || value.itemCode);
  return String(value).trim() !== "";
}

function hasPositiveNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0;
}

export function isMeaningfulQuoteItem(item) {
  if (!item || typeof item !== "object") return false;
  const length = Number(item.length) || 0;
  const height = Number(item.height) || 0;
  return (
    textFieldsThatMakeQuoteLine.some((field) => hasText(item[field])) ||
    hasPositiveNumber(item.rate) ||
    hasPositiveNumber(item.amount) ||
    (length > 0 && height > 0)
  );
}

export function cleanQuoteItemForSave(item) {
  const normalized = normalizeQuoteItem(item);
  return Object.fromEntries(
    Object.entries(normalized).map(([key, value]) => {
      if (key === "item" && value && typeof value === "object") return [key, value._id || ""];
      return [key, value];
    }).filter(([, value]) => {
      if (value == null) return false;
      if (typeof value === "string") return value.trim() !== "";
      return true;
    })
  );
}
